import React, { useState, useEffect } from 'react';

const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const CORRECT_PASSWORD = 'tPiitn';
  const AUTH_KEY = 'guag_auth';

  useEffect(() => {
    // Check if user is already authenticated
    const authStatus = sessionStorage.getItem(AUTH_KEY);
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === CORRECT_PASSWORD) {
      sessionStorage.setItem(AUTH_KEY, 'true');
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0A0A0A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          width: '8px',
          height: '8px',
          backgroundColor: '#C9A961',
          borderRadius: '50%'
        }}></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#0A0A0A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}>
        <div style={{
          maxWidth: '400px',
          width: '100%'
        }}>
          {/* Brand */}
          <div style={{
            textAlign: 'center',
            marginBottom: '48px'
          }}>
            <h1 style={{
              fontSize: '32px',
              fontWeight: 'bold',
              color: 'white',
              marginBottom: '16px',
              letterSpacing: '2px'
            }}>
              GUAG
            </h1>
            <div style={{
              height: '2px',
              width: '64px',
              background: 'linear-gradient(to right, transparent, #C9A961, transparent)',
              margin: '0 auto 24px'
            }}></div>
            <p style={{
              color: '#C9A961',
              fontSize: '12px',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}>
              Access Required
            </p>
            <p style={{
              color: '#999',
              fontSize: '16px'
            }}>
              If you're here, you know why.
            </p>
          </div>

          {/* Password Form */}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Access code"
                autoComplete="off"
                style={{
                  width: '100%',
                  padding: '16px',
                  fontSize: '16px',
                  backgroundColor: '#1A1A1A',
                  border: error ? '2px solid #DC2626' : '2px solid #2A2A2A',
                  borderRadius: '8px',
                  color: 'white',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = '#C9A961';
                }}
                onBlur={(e) => {
                  if (!error) {
                    e.target.style.borderColor = '#2A2A2A';
                  }
                }}
              />
              {error && (
                <p style={{
                  color: '#DC2626',
                  fontSize: '14px',
                  marginTop: '8px',
                  marginLeft: '4px'
                }}>
                  Invalid access code
                </p>
              )}
            </div>

            <button
              type="submit"
              style={{
                width: '100%',
                padding: '16px',
                fontSize: '16px',
                fontWeight: '600',
                backgroundColor: '#8B6F47',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.3s'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#C9A961';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#8B6F47';
              }}
            >
              Unlock
            </button>
          </form>

          {/* Decorative dots */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
            marginTop: '48px'
          }}>
            <div style={{ width: '4px', height: '4px', backgroundColor: '#444', borderRadius: '50%' }}></div>
            <div style={{ width: '4px', height: '4px', backgroundColor: '#444', borderRadius: '50%' }}></div>
            <div style={{ width: '4px', height: '4px', backgroundColor: '#444', borderRadius: '50%' }}></div>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default PasswordGate;
